<template>
  <div class="bet-detail-wrapper">
    <div class="ticket-header" v-if="currentTicket">
      <span class="ticket-header__number">
        {{ roundLabel }}
      </span>
      <div class="ticket-header__id">
        <span class="ticket-header__id-text">{{ currentTicket.sid }}</span>
        <CopyBtn :targetTxt="currentTicket.sid" />
      </div>
    </div>
    <div class="result-main-body">
      <BetDetailTable :ticket="currentTicket" />
    </div>
  </div>
</template>
<script>
import BetDetailTable from '@/components/tables/bet-detail.vue';
import CopyBtn from '@/components/copy-btn.vue';
import { mapGetters } from 'vuex';

export default {
  components: { BetDetailTable, CopyBtn },
  computed: {
    ...mapGetters('ticket', ['currentTicket']),
    // Guarded: a ticket can come without `fight.match_day`.
    roundLabel() {
      const fight = (this.currentTicket && this.currentTicket.fight) || {};
      const arena = (fight.matchDay && fight.matchDay.arena) || {};
      return `${arena.code || ''}#${fight.fightNumber || ''}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.bet-detail-wrapper {
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .ticket-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    padding: 0px 16px;
    box-sizing: border-box;

    &__number {
      flex-shrink: 0;
      color: #A1BBC9;
      font-size: 13px;
      font-weight: 600;
      text-transform: uppercase;
      white-space: nowrap;
    }

    &__id {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
      padding: 6px 10px;
      border-radius: 16px;
      background-color: rgba(16, 35, 58, 0.85);
      border: 1px solid #2a4157;
    }

    &__id-text {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #b2d6ea;
      font-size: 11px;
      font-weight: 600;
    }
  }
}
</style>
